export default (codeProduit: string) => {
    return `https://api.sim-prix.net/api/produits/${codeProduit}/images`
}